import {
	PLATFORM_CLICK_ON_PERFORMANCE_EMAILS,
	PLATFORM_CLICK_ON_PERFORMANCE_PAID_CAMPAIGN,
	PLATFORM_CLICK_ON_PERFORMANCE_PARTNERSHIPS,
	PLATFORM_CLICK_ON_PERFORMANCE_SUMMARY,
} from "../events";
import isShopifyShop from "./isShopifyShop";

const events = {
	Summary: PLATFORM_CLICK_ON_PERFORMANCE_SUMMARY,
	Network: PLATFORM_CLICK_ON_PERFORMANCE_PARTNERSHIPS,
	"Paid Campaign": PLATFORM_CLICK_ON_PERFORMANCE_PAID_CAMPAIGN,
	Emails: PLATFORM_CLICK_ON_PERFORMANCE_EMAILS,
};

const SUPPORTED_PERFORMANCE_DASHBOARDS = [
	{
		title: "Advertising",
		path: "advertising",
		key: "advertising",
	},
	{
		title: "Publishing",
		path: "publishing",
		key: "publishing",
	},
];

// TODO: EXPORT TO BE MORE GENERIC AND USE IN PLACES LIKE THE SETTINGS TAB
const genTabbedOptions = (options, activeIdx) => {
	return options.map((option) => ({
		active: option.path === activeIdx,
		name: option.title,
		urlKey: option.path,
		event: events[option.title],
	}));
};

const genSidebarOptions = (options, prefix) => {
	return options.map((option) => ({
		title: option.title,
		name: option.path,
		to: `${prefix}/${option.path}`,
		event: events[option.title],
	}));
};

export const isPerformanceInMaintenance = ({ user } = {}) =>
	!!user?.performance_maintenance_mode;

const getPerformanceSubheadings = ({
	user,
	activeIdx = null,
	sidebar = false,
} = {}) => {
	const IN_MAINTENANCE_MODE = isPerformanceInMaintenance({ user });

	const publisherDashboards = user?.publisher?.analytics_dashboards || [];

	const defaultOptions = IN_MAINTENANCE_MODE
		? []
		: SUPPORTED_PERFORMANCE_DASHBOARDS.filter((dashboard) =>
				publisherDashboards.some((d) => d.key === dashboard.key)
		  );

	return sidebar
		? genSidebarOptions(defaultOptions, "/performance")
		: genTabbedOptions(defaultOptions, activeIdx);
};

export default getPerformanceSubheadings;
